import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { ConspostratamientoUpdate } from "./ConspostratamientoUpdate";
import { ConspostratamientoDelete } from "./ConspostratamientoDelete";

export function ConspostratamientoEdit(props) {
  const conspostratamiento = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = conspostratamiento.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [conspostResp, setConspostResp] = useState(
    conspostratamiento.meta?.conspostResp
  );
  const [metaFecha, setConspostFecha] = useState(
    conspostratamiento.meta?.metaFecha
  );
  const [conspostMedio, setConspostMedio] = useState(
    conspostratamiento.meta?.conspostMedio
  );
  const [conspostTipo, setConspostTipo] = useState(
    conspostratamiento.meta?.conspostTipo
  );
  const [conspostObs, setConspostObs] = useState(
    conspostratamiento.meta?.conspostObs
  );
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let conspostratamientoId = conspostratamiento.id;

  const conspostDate = new Date(conspostratamiento.date);
  const diffDate = Math.abs(new Date() - conspostDate) / 36e5;

  const submitConspostratamiento = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await ConspostratamientoUpdate(
        conspostResp,
        metaFecha,
        conspostMedio,
        conspostTipo,
        conspostObs,
        tratamientoId,
        pacienteId,
        conspostratamientoId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/seguimiento/consulta-post-tratamiento/${conspostratamientoId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await ConspostratamientoDelete(conspostratamientoId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        {conspostratamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id="formUpdatelement" onSubmit={submitConspostratamiento}>
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="conspostResp">Responsable</label>
                  <div className="control">
                    <input
                      className="input"
                      id="conspostResp"
                      required
                      type="text"
                      value={conspostResp}
                      onChange={(e) => setConspostResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="metaFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="metaFecha"
                      required
                      type="date"
                      value={metaFecha}
                      onChange={(e) => setConspostFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="conspostMedio">Medio</label>
                  <div className="control">
                    <div className="select">
                      <select
                        className="select"
                        id="conspostMedio"
                        required
                        name="conspostMedio"
                        value={conspostMedio}
                        onChange={(e) => setConspostMedio(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="presencial">Presencial</option>
                        <option value="videoconferencia">
                          Videoconferencia
                        </option>
                        <option value="telefonico">Telefónico</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="conspostTipo">Tipo</label>
                  <div className="control">
                    <div className="select">
                      <select
                        className="select"
                        id="conspostTipo"
                        required
                        name="conspostTipo"
                        value={conspostTipo}
                        onChange={(e) => setConspostTipo(e.target.value)}
                      >
                        {props.userRole.includes("administrador") ? (
                          <>
                            <option disabled value="">
                              -- Selecciona una opción --
                            </option>
                            <option value="medica">Médica</option>
                            <option value="psicologica">Psicológica</option>
                            <option value="psiquiatrica">Psiquiátrica</option>
                            <option value="ypsilon">Ypsilon ambulatorio</option>
                          </>
                        ) : props.userRole.includes("medicina") ? (
                          <>
                            <option disabled value="">
                              -- Selecciona una opción --
                            </option>
                            <option value="medica">Médica</option>
                          </>
                        ) : ( props.userRole.includes('psicologia-hospital') || props.userRole.includes('psicologia')) ? (
                          <>
                            <option disabled value="">
                              -- Selecciona una opción --
                            </option>
                            <option value="psicologica">Psicológica</option>
                            <option value="psiquiatrica">Psiquiátrica</option>
                            <option value="ypsilon">Ypsilon ambulatorio</option>
                          </>
                        ) : (
                          <option disabled value="">
                            Sin Permisos
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field">
                <label htmlFor="conspostObs">Observaciones</label>
                <div className="control">
                  <textarea
                    className="textarea"
                    name="conspostObs"
                    id="conspostObs"
                    value={conspostObs}
                    onChange={(e) => setConspostObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
        {((diffDate <= 72) && ((props.userRole.includes('psicologia-hospital') && conspostTipo === "psicologica") || (props.userRole.includes('psicologia') && conspostTipo === "psicologica") || (props.userRole.includes('medicina') && conspostTipo === "medica")) || (props.userRole.includes('administrador')))  && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
          <Link
            className="button is-link is-light"
            to={`../${tratamientoId}/seguimiento/consulta-post-tratamiento/${conspostratamiento.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className="button is-danger"
              id="deleteButton"
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : "Eliminar"}
            </button>
          )}
        </div>
      )}
    </>
  );
}
